import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import PageLayout from '../components/common/PageLayout';
import { Link } from 'react-router-dom';

const Contact: React.FC = () => {
  const { t } = useTranslation();
  const baseUrl = process.env.REACT_APP_SEO_BASE_URL || window.location.origin;

  return (
    <>
      <Helmet>
        <title>Contact Us | MWQQ.com - Get Help & Support</title>
        <meta name="description" content="Contact MWQQ.com for support, questions, or feedback about our passport photo tool. Email us at mwqq.com@gmail.com. We respond within 24-48 hours." />
        <meta name="keywords" content="contact us, support, help, customer service, passport photo support, email contact" />
        <link rel="canonical" href={`${baseUrl}/contact.html`} />
        <meta property="og:title" content="Contact Us | MWQQ.com" />
        <meta property="og:description" content="Get in touch with MWQQ.com for support and questions." />
        <meta property="og:url" content={`${baseUrl}/contact.html`} />
        <meta property="og:type" content="website" />
      </Helmet>

      <PageLayout title={t('pages.contact.title')}>
      <p className="text-lg text-gray-700 dark:text-gray-300 mb-8">
        {t('pages.contact.intro')}
      </p>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
          {t('pages.contact.email.title')}
        </h2>
        <p className="text-gray-700 dark:text-gray-300 mb-3">
          {t('pages.contact.email.content')}
        </p>
        <a
          href="mailto:mwqq.com@gmail.com"
          className="inline-flex items-center text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 text-xl font-medium"
        >
          <svg
            className="w-6 h-6 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
          mwqq.com@gmail.com
        </a>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
          {t('pages.contact.response.title')}
        </h2>
        <p className="text-gray-700 dark:text-gray-300">
          {t('pages.contact.response.content')}
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
          {t('pages.contact.support.title')}
        </h2>
        <p className="text-gray-700 dark:text-gray-300 mb-4">
          {t('pages.contact.support.content')}
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300">
          {t('pages.contact.support.points', { returnObjects: true }).map((point: string, index: number) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
      </section>

      <section className="mb-8 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-6">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
          {t('pages.contact.faq.title')}
        </h2>
        <p className="text-gray-700 dark:text-gray-300 mb-3">
          {t('pages.contact.faq.content')}
        </p>
        <Link
          to="/faq.html"
          className="inline-flex items-center text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 font-medium"
        >
          Visit FAQ Page
          <svg
            className="w-5 h-5 ml-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </Link>
      </section>
      </PageLayout>
    </>
  );
};

export default Contact;
